import {Module} from "vuex";
import {IDBase, QueryFacade} from "@/controller/QueryFacade";

export class DieAndToolCodeRow implements IDBase {
    readonly id: string="";
    public dieToolName: string = "";
    public dieToolPostfix: string = "";

}

export class DieAndToolCodeMap implements IDBase{
    id: string;
    map:Array<DieAndToolCodeRow> = [];

    constructor(id: string) {
        this.id = id;
    }
}

export class ProductionSourceRow{
    public stampsImport:string="";
    public shorthand:string="";
}

export class ProductionSourceMap{
    id: string;
    map:Array<ProductionSourceRow> = [];

    constructor(id: string) {
        this.id = id;
    }
}

export class ImportConfigStates{
    DieAndToolCodeMap:DieAndToolCodeMap = new DieAndToolCodeMap("DieAndToolCodeMap");
    ProductionSourceMap:ProductionSourceMap = new ProductionSourceMap("ProductionSourceMap");
}

export class ImportConfigStore implements Module<any, unknown> {
    public namespaced = true;
    public state:ImportConfigStates = new ImportConfigStates();

    public getters:{[func:string]:()=>any} = {

    };

    public mutations = {
        addCodeRow(state:ImportConfigStates){
            state.DieAndToolCodeMap.map.push(new DieAndToolCodeRow());
        },
        addSourceRow(state:ImportConfigStates){
            state.ProductionSourceMap.map.push(new ProductionSourceRow());
        },
        persist(state:ImportConfigStates){
            for (let key of Object.keys(state)) {
                QueryFacade.put("import_config", (<any>state)[key]);
            }
        },

        async loadFromDb(state:ImportConfigStates){
            const orgstate = new ImportConfigStates();
            for (let key of Object.keys(orgstate)) {
                const res = await < IDBase > <any>QueryFacade.get("import_config", key);
                (<any>importConfigStore).state[key] = (<any>orgstate)[key];
                if(res) {
                    (<any>importConfigStore).state[res.id] = res;
                }
            }
        }
    };


    constructor() {
        for (let key of Object.keys(this.state)) {
            this.getters[key] = ()=>{
                return (<any>this.state)[key];
            }
        }
    }
}

export const importConfigStore = new ImportConfigStore();